<template>
  <VBtn
    :variant="props.variant"
    :color="props.color"
    :disabled="props.disabled"
    :title="props.title"
    :size="props.size"
    :prepend-icon="props.prependIcon"
    :loading="props.loading"
    :ripple="false"
    :icon="props.icon"
    :href="props.href"
    :rounded="props.rounded"
    :value="props.value"
  >
    <template
      v-if="slots.prepend"
      #prepend
    >
      <slot name="prepend" />
    </template>

    <slot />

    <template
      v-if="slots.append"
      #append
    >
      <slot name="append" />
    </template>
  </VBtn>
</template>

<script setup lang="ts">
import { VuetifyBtnVariants, VuetifyColors, VuetifyDensity, VuetifySizes } from "@/src/easy-ui/types";

interface Props {
  variant?: VuetifyBtnVariants;
  color?: VuetifyColors;
  disabled?: boolean;
  title?: string;
  density?: VuetifyDensity;
  size?: VuetifySizes;
  icon?: string;
  prependIcon?: string;
  loading?: boolean | string;
  href?: string;
  rounded?: boolean;
  value?: string | number;
}

const slots = defineSlots();

const props = withDefaults(defineProps<Props>(), {
  variant: VuetifyBtnVariants.Flat,
  color: undefined,
  disabled: false,
  title: undefined,
  density: VuetifyDensity.Default,
  size: VuetifySizes.Default,
  icon: undefined,
  prependIcon: undefined,
  loading: false,
  href: undefined,
  rounded: false,
  value: undefined,
});
</script>
